﻿import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';


import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';

import { JwtInterceptor, ErrorInterceptor } from './_interceptors';
import { HomeComponent } from './public/home';
import { LoginComponent, ChangePasswordComponent, SocialComponent } from './public/login';
import { RegisterComponent } from './public/register';
import { AlertComponent } from './_components/alert';
import { RestComponent } from './root/rest';
import { UsersComponent, EditUserComponent } from './root/users';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TablaComponent } from './_components/tabla';
import { RouterModule } from '@angular/router';
import { RootProductoComponent } from './root/producto/producto.component';
import { CrearComponent } from './user/crear/crear.component';
import { ListasComponent } from './user/listas/listas.component';
import { RecibirComponent } from './public/recibir/recibir.component';
import { DetalleComponent } from './user/listas/detalle.component';
import { EmpezarComponent } from './public/regalar/empezar.component';
import { ListaRegalosComponent } from './public/regalar/lista.regalos.component';
import { ResumenRegalosComponent } from './public/regalar/resumen.regalos.component';
import { RootListaComponent } from './root/lista/lista.component';
import { RootPedidoComponent } from './root/lista/pedido.component';
import { GraciasComponent } from './user/gracias/gracias.component';
import { PublicGraciasComponent } from './public/regalar/gracias.component';
import { PublicPendienteComponent } from './public/regalar/pendiente.component';
import { PublicFailureComponent } from './public/regalar/failure.component';
import { RootParametrosComponent } from './root/parametros/parametros.component';
import { AnonimaComponent } from './public/anonima/anonima.component';
import { RegalarComponent } from './public/regalar/regalar.component';
import { NuevoProductoComponent } from './root/producto/nuevo.component';
import { GoogleAnalyticsService } from './_services/analytics.service';
import { ProductoComponent } from './_components/producto/producto.component';


@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        FormsModule,
        RouterModule.forRoot(
            appRoutes, { 
                onSameUrlNavigation: 'reload' , 
                useHash: true, 
                scrollPositionRestoration: 'enabled',        
                anchorScrolling: 'enabled',
                scrollOffset: [0, 64]
            }),
        BlockUIModule.forRoot(),
        BlockUIHttpModule.forRoot(),
        BrowserAnimationsModule,
        NgxJsonViewerModule,
        NgxDatatableModule
    ],
    declarations: [
        AppComponent,
        AlertComponent,
        HomeComponent,
        LoginComponent,
        RegisterComponent,
        RestComponent,
        UsersComponent,
        EditUserComponent,
        ChangePasswordComponent,
        SocialComponent,
        TablaComponent,
        RootProductoComponent,
        CrearComponent,
        ListasComponent,
        RecibirComponent,
        DetalleComponent,
        EmpezarComponent,
        ListaRegalosComponent,
        ResumenRegalosComponent,
        RootListaComponent,
        GraciasComponent,
        PublicGraciasComponent,
        RootParametrosComponent,
        AnonimaComponent,
        RegalarComponent,
        NuevoProductoComponent,
        ProductoComponent,
        PublicPendienteComponent,
        PublicFailureComponent,
        RootPedidoComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        GoogleAnalyticsService
    ],
    bootstrap: [AppComponent],
    exports: [RouterModule]

})

export class AppModule { }
